import React from 'react';
import './LeadgenLoading.css';

/**
 * Leadgen Consolidated Loading Component
 * Supports inline centering or full-page overlay with an optional spinner.
 */
const Loading = ({ message = 'Loading...', fullPage = false, showSpinner = true }) => {
  return (
    <div className={`tm-loading-container ${fullPage ? 'full-page' : ''}`}>
      {showSpinner && <div className="tm-loading-spinner" />}
      <span className="tm-loading-text">{message}</span>
    </div>
  );
};

export default Loading;
